// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { type OutcomeMode } from '../../../types/outcome';
import ImmersiveOutcomeWithVariation from '../components/ImmersiveOutcomeWithVariation';
import outcomeWithVariationSelector from '../selectors/outcomeWithVariation';

type ImmersiveOutcomeWithVariationContainerProps = {
  className?: string;
  oddId: number;
  label: string;
  handleClick: (value: unknown) => void;
  mode: OutcomeMode;
};

const ImmersiveOutcomeWithVariationContainer = ({
  oddId,
  ...ownProps
}: ImmersiveOutcomeWithVariationContainerProps) => {
  const selectorProps = useMemo(() => ({ oddId }), [oddId]);
  const selectedProps = useSelector((state) => outcomeWithVariationSelector(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <ImmersiveOutcomeWithVariation {...enhancedProps} />;
};

export default ImmersiveOutcomeWithVariationContainer;
